import * as React from 'react';

import { useDesignSystemFlags } from '../../../Hooks';
import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';

function SvgPinBorderIconV1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2a3 3 0 00-3 3v5.667L4.5 14c-1.236 1.648-.06 4 2 4H11v4a1 1 0 102 0v-4h4.5c2.06 0 3.236-2.352 2-4L17 10.667V5a3 3 0 00-3-3h-4zm2.004 14H17.5a.5.5 0 00.4-.8L15 11.333V5a1 1 0 00-1-1h-4a1 1 0 00-1 1v6.333L6.1 15.2a.5.5 0 00.4.8h5.504z"
        fill="currentColor"
      />
    </svg>
  );
}

function SvgPinBorderIconV2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 0A.75.75 0 005 .75v4.007a2.25 2.25 0 01-.659 1.591L2.22 8.47A.75.75 0 002 9v2.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 00.75-.75V9a.75.75 0 00-.22-.53L11.66 6.348A2.25 2.25 0 0111 4.758V.75a.75.75 0 00-.75-.75h-4.5zm.75 4.757V1.5h3v3.257a3.75 3.75 0 001.098 2.652L12.5 9.311V10.5h-9V9.31L5.402 7.41A3.75 3.75 0 006.5 4.757z"
        fill="currentColor"
      />
    </svg>
  );
}

function PinBorderIcon(props: IconProps) {
  const { USE_NEW_ICONS } = useDesignSystemFlags();
  const component = USE_NEW_ICONS ? SvgPinBorderIconV2 : SvgPinBorderIconV1;
  return <Icon {...props} component={component} />;
}

export default PinBorderIcon;
